document.addEventListener("DOMContentLoaded", function() {

    if(isPersonalisedProduct()){

    }else{

        document.querySelector('.sticky-atc-button').addEventListener('click',() => {
    
            document.querySelector(`.product-form__submit.button`).click()
    
        })

        setStickyDefault();

        let firstTimeUrl = document.URL;
        document.addEventListener('change', function() {
            let currentPageUrl = document.URL;
            let url = new URL(currentPageUrl);
            let isVariantUrl = url.searchParams.get("variant");
            currentPageUrl = isVariantUrl ? currentPageUrl :isVariantUrl;
            if(currentPageUrl && firstTimeUrl != currentPageUrl) {
                firstTimeUrl = currentPageUrl;
                setTimeout(() => {
                    setStickyDefault();
                }, 1500);
            }
        });
        
        document.querySelector('.sticky-atc-product').classList.add("sticky-atc-product--active")

    }
    checkIfVisibleStickyATC(true);
});

function setStickyDefault(){
    let button = document.querySelector('.sticky-atc-button');
    if(document.querySelector(".product-form__submit.button").innerText == "SOLD OUT"){
        button.setAttribute("disabled","")
        button.style.backgroundColor = Window.stickyATCSettings.ATC.button_background;
        button.style.color = Window.stickyATCSettings.ATC.text_color;
        button.style.opacity = 0.5;
        button.innerText = "SOLD OUT"
    }else{
        button.removeAttribute("disabled")
        button.style.backgroundColor = Window.stickyATCSettings.ATC.button_background;
        button.style.color = Window.stickyATCSettings.ATC.text_color;
        button.style.opacity = 1;
        button.innerText = Window.stickyATCSettings.ATC.text;
    }
}

function getRequiredFields(){
    return document.querySelector('.product-personalizer').querySelectorAll(`[required]`);
}

function requiredFieldsListener(){
    getRequiredFields().forEach(input => {
        input.addEventListener('change', () => {
            if(isAllFieldsSatisfied()){
                setStickyButton(Window.stickyATCSettings.ATC)
            }else{
                setStickyButton(Window.stickyATCSettings.NOS)
            }
        })  
    })
}



function setStickyButton(obj){

    let stickyButton =  document.querySelector('.sticky-atc-button');

    let text = obj.text;
    let fontColor = obj.text_color;
    let background_color = obj.button_background;

    stickyButton.innerHTML = `${text}`
    stickyButton.style.color = `${fontColor}`;
    stickyButton.style.backgroundColor = `${background_color}`


}

function isAllFieldsSatisfied(){
    let threshold = getRequiredFields().length;
    let isSatisfied = 0;
    getRequiredFields().forEach(input => {
        if(input.value != undefined && input.value != null && input.value != ""){
            isSatisfied++;
        } 
    })

    if(isSatisfied == threshold){
        return true;
    }else{
        return false;
    }
}

function isPersonalisedProduct(){
    return document.querySelector('.product-personalizer') != null;
}

function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

document.addEventListener('scroll', function(e) {
    checkIfVisibleStickyATC();
});

function checkIfVisibleStickyATC(initalLoad){

    let normalATC = document.querySelector(".product-form__submit.button");
    let stickyATC = document.querySelector('.sticky-atc-product');

    if(initalLoad){ 
        document.querySelector('.sticky-atc-product').classList.remove("sticky-atc-product--active")
    }

    if(isInViewport(normalATC) && window.innerWidth < 900 && stickyATC.style.opacity != 0){
        stickyATC.style.opacity = 0;
        setTimeout(() => {
            stickyATC.style.display = "none"
        }, 450);

    }else if(!isInViewport(normalATC) && window.innerWidth < 900 && stickyATC.style.opacity == 0 ){
        stickyATC.style.display = "block";

        if(!document.querySelector('.sticky-atc-product').classList.contains("sticky-atc-product--active")){
            document.querySelector('.sticky-atc-product').classList.add("sticky-atc-product--active")
        }
        setTimeout(() => {
            stickyATC.style.opacity = 1
        }, 450);
    }
}
